export default function Marquee({ items, className = "" }) {
  const row = (hidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((t, i) => (
        <span key={`${t}-${i}`} className="flex items-center font-mono text-[11px] tracking-[0.28em] text-slate-400">
          <span className="px-7">{t}</span>
          <span className="text-sonoma text-[8px]">◆</span>
        </span>
      ))}
    </div>
  );
  return (
    <div className={`marquee-paused overflow-hidden border-y border-white/8 py-3 ${className}`} data-testid="stack-marquee">
      <div className="animate-marquee flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
